module.exports = __webpack_public_path__ + "img/1_021.c7719b6a.jpg";